export * from "./produtos-consignacao.component";
